import React from 'react';
import TeacherFixRouter from '../containers/TeacherFixRouter';

export default (props) => (
  <TeacherFixRouter {...props} />
);
